import { useState } from 'react';

const STEPS = {
  CREATE_ORDER: 'createOrder',
  CHOOSE_METHOD: 'chooseMethod',
  PROCESSING: 'processing',
  APPROVED: 'approved',
};

export const usePurchaseFlow = () => {
  const [currentStep, setCurrentStep] = useState(STEPS.CREATE_ORDER);
  const [data, setData] = useState({});
  const [orderResponse, setOrderResponse] = useState(null);

  const goNext = (newData = {}, shouldClose = false) => {
    const { serviceResponse, ...formData } = newData;

    if (serviceResponse) {
      setOrderResponse(serviceResponse);
    }

    setData(prev => ({ ...prev, ...formData }));

    if (shouldClose) {
      return 'CLOSE_MODAL';
    }

    if (currentStep === STEPS.CREATE_ORDER) {
      setCurrentStep(STEPS.CHOOSE_METHOD);
    } else if (currentStep === STEPS.CHOOSE_METHOD) {
      setCurrentStep(STEPS.PROCESSING);
    } else if (currentStep === STEPS.PROCESSING) {
      setCurrentStep(STEPS.APPROVED);
    } else if (currentStep === STEPS.APPROVED) {
      return 'CLOSE_MODAL';
    }
  };

  const goBack = () => {
    if (currentStep === STEPS.CHOOSE_METHOD) {
      setCurrentStep(STEPS.CREATE_ORDER);
    }
  };

  const reset = () => {
    setCurrentStep(STEPS.CREATE_ORDER);
    setData({});
    setOrderResponse(null);
  };

  return {
    currentStep,
    data,
    orderResponse,
    goNext,
    goBack,
    reset,
    STEPS,
  };
};
